export default __webpack_public_path__ + "static/media/loader.b67028d8.svg";